import { Fragment, ReactNode } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Row } from "./Stack";
import { Box } from "./Box";

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  children: ReactNode;
}

export const Modal = ({ isOpen, closeModal, children }: ModalProps) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-20" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-100"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0" />
        </Transition.Child>

        <Box
          minHeight="min-h-full"
          position="fixed"
          top="top-0"
          left="left-0"
          right="right-0"
          bottom="bottom-0"
          overflowY="auto"
        >
          <div className="h-full bg-black bg-opacity-60 backdrop-blur-sm">
            <Row justify="center" align="center" fullHeight={true}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-100"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-fit transform overflow-hidden rounded shadow-xl transition-all">
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </Row>
          </div>
        </Box>
      </Dialog>
    </Transition>
  );
};
